export const defaultJSONMapping = `
{
    "PCProduct":
    {
    "ComingFrom": "Securaze",
    "Type": "PC",
    "Name": "{Model}",
    "Vendor": "{Vendor}",
    "AssetID": "{ExternalID}",
    "SerialNumber": "{SerialNumber}",
    "Chassis": "{Chassis}",
    "OperatingSystem": "{OS}",
    "DVD": "{DVD}",
    "RAM": "{RAM}",
    "DisplaySize": "{DisplaySize}",
    "CreatedAt": "{CreatedAt}",
    "InternationalGrading": "{Grade}",
    "TypicalProblems": "{TypicalProblems}",
    "DiskDrives": "{Disks}",
    "Processors": "{CPUComponents}",
    "Batteries": "{BatteryComponents}",
    "Motherboards": "{MotherboardComponents}",
    "GPUs": "{GPUComponents}",
    "NetworkInterfaces":
    "{NetworkComponents}",
    "Memory": "{MemoryComponents}",
    "LabelComment1": "{LabelComment1}",
    "LabelComment2": "{LabelComment2}",
    "LabelComment3": "{LabelComment3}",
    "LabelComment4": "{LabelComment4}",
    "CommaSeparatedWipeMethods": "{Disks[,].WipeMethod}",
    "TypicalProblemCodes": "{TypicalProblemCodes}",
    "SecurazeID": "{SecurazeID}",
    "HardwareID": "{HardwareID}",
    "DiagnoseResults": "{DiagnoseResults}",
    "Container": "{Colli}"
    },
    "MobileProduct":
    {
    "ComingFrom": "Securaze",
    "Type": "Mobile",
    "Name": "{Model}",
    "Vendor": "{Vendor}",
    "AssetID": "{ExternalID}",
    "SerialNumber": "{SerialNumber}",
    "Chassis": "{Chassis}",
    "OperatingSystem": "{OS}",
    "IMEI": "{IMEI}",
    "IMEI2": "{IMEI2}",
    "InternationalGrading": "{Grade}",
    "TypicalProblems": "{TypicalProblems}",
    "DiskDrives": "{Disks}",
    "Processors": "{CPUComponents}",
    "Batteries": "{BatteryComponents}",
    "Motherboards": "{MotherboardComponents}",
    "GPUs": "{GPUComponents}",
    "NetworkInterfaces": "{NetworkComponents}",
    "Memory": "{MemoryComponents}",
    "LabelComment1": "{LabelComment1}",
    "LabelComment2": "{LabelComment2}",
    "LabelComment3": "{LabelComment3}",
    "LabelComment4": "{LabelComment4}",
    "CommaSeparatedWipeMethods": "{Disks[,].WipeMethod}",
    "TypicalProblemCodes": "{TypicalProblemCodes}",
    "SecurazeID": "{SecurazeID}",
    "HardwareID": "{HardwareID}",
    "DiagnoseResults": "{DiagnoseResults}",
    "Container": "{Colli}"
    },
    "DisplayProduct": {},
    "StorageProduct": {}
    }
`